import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useState } from 'preact/hooks'
import { useAction } from '../api/useAction'

export function EnrollDialog({
  onSubmit,
  onClose,
}: {
  onSubmit: (email: string) => Promise<void>
  onClose: () => void
}) {
  const [email, setEmail] = useState('')
  const { error, pending, run } = useAction()
  const submit = (e: Event) => {
    e.preventDefault()
    run(() => onSubmit(email))
  }
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={submit}>
        <DialogTitle>Inscrire un bénévole</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Le bénévole est validé sur ce créneau ; son compte est créé s'il n'existe pas.
            </Typography>
            <TextField
              label="Email du bénévole"
              type="email"
              required
              autoFocus
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            />
            {error && <Alert severity="error">{error}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Annuler</Button>
          <Button type="submit" variant="contained" loading={pending}>
            Inscrire
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
